import React, { useCallback, useMemo } from 'react';
import Searcher from './Searcher';
import { generateColumnsDefaultConfiguration } from '../../../../../../components/dataGrid/columnHelpers';
import { adaptCapasArray, GET_CAPAS_PAGINATED_RECLAMOS } from '../../../../../../data/graphQL/queries/Reclamos/getAllCapas';

const NumeroCapaField = ({
    onChange,
    idCapaReclamo,
    disabled,
    idDelegacion
}) => {

    const CONFIGURATED_COLUMNS = useMemo(() => (generateColumnsDefaultConfiguration(columns)), [columns]);

    const getSearchParams = useCallback((textValue) => {
        const filterDelegacion = {
            idDelegacion: { eq: idDelegacion }
        };

        const searchParams = {
            and: [filterDelegacion]
        };

        if (textValue) {
            searchParams.and.push({
                or: [
                    !isNaN(parseInt(textValue)) ? { idGestionCapa: { eq: parseInt(textValue) } } : {},
                    { idFuenteNavigation: { descripcion: { contains: textValue } } },
                    { idAreaNavigation: { descripcion: { contains: textValue } } },
                    { idFuenteNavigation: { descripcion: { contains: textValue } } },
                ]
            });
        }

        return searchParams;
    }, [idDelegacion]);

    const handleRowClick = (row) => {
        onChange('idCapaReclamo', row?.idCapa);
    }

    const getEntityValue = (row) => {
        const value = !!row ? `${row.idCapa}` : null;
        return value;
    }

    return <Searcher
        displayName='Nro CAPA'
        titleModal='Seleccionar CAPA'
        entityName='allGestionCapa'
        entityId='idGestionCapa'
        entityIdValue={idCapaReclamo}
        columns={CONFIGURATED_COLUMNS}
        query={GET_CAPAS_PAGINATED_RECLAMOS}
        adapter={adaptCapasArray}
        getSearchParams={getSearchParams}
        onRowClick={handleRowClick}
        getEntityValue={getEntityValue}
        disabled={disabled}
    />
}

export default NumeroCapaField;

const columns = [
    {
        field: 'idCapa',
        headerName: 'Id',
        flex: 1
    },
    {
        field: 'fechaApertura',
        headerName: 'F. de Apertura',
        type: 'date',
        flex: 1.5
    },
    {
        field: 'fuente',
        headerName: 'Fuente',
        flex: 1,
    },
    {
        field: 'area',
        headerName: 'Area',
        flex: 2
    },
    {
        field: 'delegacion',
        headerName: 'Delegación',
        type: 'date',
        flex: 1.5,
    },
];